import { Spin } from 'antd'
import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Actions from '../../../actions'
import { routes } from '../../../consts'
import { isProduction } from '../../../utils/envUtils'

import './AskNicely.css'

const AskNicely = () => {
  const dispatch = useDispatch()
  const askNicelySlug = useSelector(state => state.account.askNicelySlug)
  let template_name = isProduction ? 'general-prod' : 'general-dev'

  useEffect(() => {
    window.addEventListener('message', getAnswer)
    return () => window.removeEventListener('message', getAnswer)
  }, [])

  useEffect(() => {
    dispatch(
      Actions.createAction(Actions.ASK_NICELY_SLUG_REQUESTED, { template_name })
    )
  }, [])

  const getAnswer = event => {
    if (event?.data?.key === 'finished') {
      dispatch(
        Actions.createAction(Actions.NAVIGATED_TO, routes.THANK_YOU_PAGE)
      )
    }
  }

  return (
    <>
      {askNicelySlug ? (
        <iframe
          src={`https://antidotehealth.asknice.ly/email/conversation/${askNicelySlug}?template_name=${template_name}&inapp`}
          height={'100%'}
          width={'100%'}
          style={{ border: 'none' }}
        ></iframe>
      ) : (
        <div>
          <Spin size="large"></Spin>
        </div>
      )}
    </>
  )
}
export default AskNicely
